/**
 * Developer Pixel-Art Sprites
 * Decorative floating characters in the hero section with 8-bit speech bubbles.
 * Characters do office things: type on laptops, wear headphones, sip coffee, etc.
 * Randomized positions and dialogs on every page load.
 */
(function () {
    'use strict';

    var container = document.querySelector('.hero-sprites');
    if (!container) return;

    var PX = 4; // Each grid cell = 4×4 CSS pixels (10×14 grid = 40×56px sprite)

    // Palette: 0=transparent, 1=skin, 2=hair, 3=shirt, 4=pants, 5=accent/shoes, 6=prop
    var characters = [
        {
            name: 'Laptop Coder',
            lines: ['It works on my machine.', 'const fix = true;', 'Have you tried restarting?'],
            palette: ['transparent','#f2c9a0','#4b2e1f','#3b82f6','#1e3a8a','#93c5fd','#64748b'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,3,3,0],
                [0,1,3,3,3,3,3,3,1,0],
                [0,0,1,6,6,6,6,1,0,0],
                [0,0,0,6,6,6,6,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0]
            ]
        },
        {
            name: 'Headphone Dev',
            lines: ['In the zone. Do not disturb.', 'This playlist slaps.', "Can't hear you, sorry."],
            palette: ['transparent','#e8b98d','#2f2f2f','#f59e0b','#7c2d12','#fde68a','#a855f7'],
            grid: [
                [0,0,6,2,2,2,2,6,0,0],
                [0,6,2,2,2,2,2,2,6,0],
                [0,6,1,1,1,1,1,1,6,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,3,3,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,0,0,3,3,3,3,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Coffee Sipper',
            lines: ['But first, coffee.', 'Is it coffee o\u2019clock yet?', 'Fueled by caffeine.'],
            palette: ['transparent','#f0c7a4','#312e81','#8b5cf6','#4c1d95','#ddd6fe','#92400e'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,3,3,0],
                [0,0,3,3,3,3,1,0,0,0],
                [0,0,0,3,3,3,1,6,6,0],
                [0,0,0,4,4,4,0,6,6,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Phone Scroller',
            lines: ['Checking prod... again.', 'Slack says it\u2019s urgent.', 'Just one more PR review.'],
            palette: ['transparent','#d9a679','#7f1d1d','#ef4444','#7f1d1d','#fecaca','#334155'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,1,0,0],
                [0,0,3,3,3,3,1,6,0,0],
                [0,0,0,3,3,3,0,6,0,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Whiteboard Writer',
            lines: ['Let me diagram this.', 'Architecture time!', 'It\u2019s simple, look...'],
            palette: ['transparent','#cfa07a','#14532d','#22c55e','#166534','#bbf7d0','#e2e8f0'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,1,6,6],
                [0,0,3,3,3,3,3,0,6,6],
                [0,0,0,3,3,3,3,0,6,6],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Book Reader',
            lines: ['RTFM, seriously.', 'The docs say otherwise.', 'Chapter 7, page 42.'],
            palette: ['transparent','#f2c9a0','#0f172a','#06b6d4','#164e63','#a5f3fc','#f59e0b'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,1,3,3,3,3,3,3,1,0],
                [0,0,1,6,6,6,6,1,0,0],
                [0,0,0,6,6,6,6,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'High-Fiver',
            lines: ['Ship it!', 'LGTM!', 'Deploy Friday? Sure!'],
            palette: ['transparent','#e5b38a','#78350f','#eab308','#854d0e','#fde047','transparent'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,3,1,0],
                [0,0,3,3,3,3,3,0,1,0],
                [0,0,0,3,3,3,3,0,1,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Box Carrier',
            lines: ['New deploy incoming!', 'Delivering features.', 'Special delivery!'],
            palette: ['transparent','#e7bc96','#450a0a','#f43f5e','#881337','#fda4af','#a16207'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,1,6,6,6,6,6,6,1,0],
                [0,0,6,6,6,6,6,6,0,0],
                [0,0,6,6,6,6,6,6,0,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Zen Coder',
            lines: ["We'll refactor later.", 'Om... merge conflict.', 'Inner peace = clean code.'],
            palette: ['transparent','#e0b088','#365314','#84cc16','#3f6212','#d9f99d','transparent'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,3,3,3,3,3,3,3,3,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,1,0,3,3,3,3,0,1,0],
                [0,4,4,4,4,4,4,4,4,0],
                [0,0,4,4,4,4,4,4,0,0],
                [0,0,5,0,0,0,0,5,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            name: 'Celebrator',
            lines: ['It passed CI!', 'Zero bugs! (probably)', "Let's celebrate!"],
            palette: ['transparent','#e8bc98','#1e1b4b','#6366f1','#312e81','#c7d2fe','transparent'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],
                [0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],
                [0,0,0,1,1,1,1,0,0,0],
                [1,0,3,3,3,3,3,3,0,1],
                [0,1,3,3,3,3,3,3,1,0],
                [0,0,3,3,3,3,3,3,0,0],
                [0,0,0,3,3,3,3,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],
                [0,0,0,0,0,0,0,0,0,0]
            ]
        }
    ];

    // Fixed positions: U-shape layout keeping the center clear for jumbotron text
    // bubble: 'below' for top sprites (so bubble doesn't leave viewport)
    // bubble: 'above' for bottom sprites (default)
    // align: 'left' → bubble anchored left, 'right' → anchored right, default → centered
    var positions = [
        { x: '8%',  y: '8%',  tier: 1, bubble: 'below', align: 'left' },
        { x: '84%', y: '10%', tier: 1, bubble: 'below', align: 'right' },
        { x: '10%', y: '35%', tier: 2, bubble: 'below', align: 'left' },
        { x: '82%', y: '33%', tier: 2, bubble: 'below', align: 'right' },
        { x: '8%',  y: '60%', tier: 1, bubble: 'above', align: 'left' },
        { x: '84%', y: '58%', tier: 1, bubble: 'above', align: 'right' },
        { x: '12%', y: '80%', tier: 3, bubble: 'above', align: 'left' },
        { x: '80%', y: '78%', tier: 3, bubble: 'above', align: 'right' },
        { x: '24%', y: '84%', tier: 3, bubble: 'side-right' },
        { x: '70%', y: '82%', tier: 3, bubble: 'side-left' }
    ];

    // Fisher-Yates shuffle
    function shuffle(arr) {
        for (var i = arr.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = arr[i];
            arr[i] = arr[j];
            arr[j] = tmp;
        }
        return arr;
    }

    // Randomize which character goes to which position
    shuffle(characters);

    function buildSVG(char) {
        var cols = char.grid[0].length;
        var rows = char.grid.length;
        var w = cols * PX;
        var h = rows * PX;
        var rects = [];

        for (var r = 0; r < rows; r++) {
            for (var c = 0; c < cols; c++) {
                var idx = char.grid[r][c];
                if (idx === 0) continue;
                rects.push(
                    '<rect x="' + (c * PX) + '" y="' + (r * PX) +
                    '" width="' + PX + '" height="' + PX +
                    '" fill="' + char.palette[idx] + '"/>'
                );
            }
        }

        return '<svg class="dev-sprite__art" width="' + w +
               '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h +
               '" xmlns="http://www.w3.org/2000/svg">' +
               rects.join('') + '</svg>';
    }

    // Inject sprites
    characters.forEach(function (char, i) {
        var pos = positions[i];
        var line = char.lines[Math.floor(Math.random() * char.lines.length)];

        var el = document.createElement('div');
        el.className = 'dev-sprite';
        el.setAttribute('data-sprite-tier', String(pos.tier));
        el.setAttribute('data-bubble', pos.bubble);
        if (pos.align) el.setAttribute('data-align', pos.align);
        el.setAttribute('role', 'img');
        el.setAttribute('aria-label', char.name + ' says: ' + line);
        el.style.left = pos.x;
        el.style.top = pos.y;

        el.innerHTML = buildSVG(char) +
            '<div class="dev-sprite__bubble">' +
                '<span class="dev-sprite__line">\u201C' + line + '\u201D</span>' +
                '<span class="dev-sprite__name">\u2014 ' + char.name + '</span>' +
            '</div>';

        container.appendChild(el);
    });

    // Touch support: toggle .is-active on tap, dismiss on outside tap
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var isMobileViewport = window.innerWidth <= 991;

    if (isTouchDevice && !isMobileViewport) {
        var activeSprite = null;

        container.addEventListener('click', function (e) {
            var sprite = e.target.closest('.dev-sprite');

            if (sprite) {
                if (activeSprite === sprite) {
                    sprite.classList.remove('is-active');
                    activeSprite = null;
                } else {
                    if (activeSprite) activeSprite.classList.remove('is-active');
                    sprite.classList.add('is-active');
                    activeSprite = sprite;
                }
                e.stopPropagation();
            }
        });

        document.addEventListener('click', function () {
            if (activeSprite) {
                activeSprite.classList.remove('is-active');
                activeSprite = null;
            }
        });
    }
})();
